import Button from "../../../../components/UI/Button";
import React from "react";
import {checkPermission} from "../../../../util/auth";

const HomeSectionCardActions = ({ clickHandler}) => {
  return (
      <>
          {checkPermission(['CATEGORY_CREATE']) &&
              <Button
                  text="+ Add a New Category"
                  variant={"btn_black"}
                  onClickHandler={clickHandler}
              />
          }
      </>
  );
}

export default HomeSectionCardActions